<div [cm-tooltip]="list">
  @if (items.length) {
    <span [innerHTML]="preview"></span>
    @if (items.length > previewLength) {
      <span class="cl-selected-color">&nbsp;+{{ items.length - previewLength}}</span>
    }
  }

  @if (!items.length) {
    {{ empty }}
  }
</div>
